import { render, staticRenderFns } from "./VehicleDetails.vue?vue&type=template&id=337e9367&scoped=true"
import script from "./VehicleDetails.vue?vue&type=script&lang=js"
export * from "./VehicleDetails.vue?vue&type=script&lang=js"
import style0 from "./VehicleDetails.vue?vue&type=style&index=0&id=337e9367&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337e9367",
  null
  
)

export default component.exports